import _ from 'underscore';

import { Order } from '~src/spacesPlatform/models/sort/Order';

import { ContentFiltersKeys } from '../../spacesPlatform/models/ContentFilters';
import { IContentType, ViewStatFields } from '../../spacesPlatform/models/ContentTypes';
import { OrderKeys } from '../../spacesPlatform/models/OrderKeys';

export const MetricContentType: IContentType = {
  name: 'metric',
  filterKeys: _.compact([
    ContentFiltersKeys.search,
    ContentFiltersKeys.favorite,
    ContentFiltersKeys.location,
    ContentFiltersKeys.project,
    ContentFiltersKeys.owner,
    ContentFiltersKeys.tag,
    ContentFiltersKeys.modifiedAfter,
    ContentFiltersKeys.modifiedBefore,
    ContentFiltersKeys.createdAfter,
    ContentFiltersKeys.createdBefore,
    ContentFiltersKeys.recent
  ]),
  canShowFilterPanel: true,
  orderKeys: [
    OrderKeys.name,
  ],
  extraQueryParams: {
    statFields: ViewStatFields
  },
  defaultOrder: [Order.asc(OrderKeys.name)],
};
